import { Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import React, { memo, useEffect, useState } from 'react';

import { L } from '@lib';

import { PaymentService } from '@services';
const { Option } = Select;

interface IProps {
  hideFirstOption?: boolean;
  payment?: string;
  fullWidth?: boolean;
  onChange?: ((value: string, option: DefaultOptionType | DefaultOptionType[] | undefined) => void) | undefined;
}

export const InvoicePaymentSelect: React.FC<IProps> = memo(
  
  ({ hideFirstOption = false, fullWidth = false, payment, onChange }) => {
     const [isPaymentEnabled, setIsPaymentEnabled] = useState(false);
    
    useEffect(() => {
      const checkPaymentEnabled = async () => {
        const hasTerminalConfigured = await PaymentService.hasTerminalEnabled();
        setIsPaymentEnabled(hasTerminalConfigured);
      };
      
      checkPaymentEnabled();
    }, []);

    return (
      <Select
        style={{ width: fullWidth ? '100%' : 160 }}
        placeholder={L('Select payment method')}
        value={payment}
        onChange={onChange}
      >
        {!hideFirstOption && <Option value={undefined}>{L('All')}</Option>}
        {isPaymentEnabled && <Option value="Card">{L('Credit card')}</Option>}
        <Option value="Cash">{L('Cash')}</Option>
        <Option value="Bank">{L('Bank transfer')}</Option>
      </Select>
    );
  }
);
